import { create } from 'zustand'

export interface IncomingAsset {
  id: string
  name: string
  previewUrl?: string
  status: 'loading' | 'error'
  error?: string
}

interface AidaPipState {
  active: boolean
  dragging: boolean
  pipWindow: Window | null
  container: HTMLElement | null
  chatSlot: HTMLDivElement | null
  generationActive: boolean
  incoming: IncomingAsset[]
}

export const useAidaPipStore = create<AidaPipState>(() => ({
  active: false,
  dragging: false,
  pipWindow: null,
  container: null,
  chatSlot: null,
  generationActive: false,
  incoming: [],
}))

let skipOverlayRestore = false

export function takePipOverlayRestore() {
  if (!skipOverlayRestore) {
    return true
  }
  skipOverlayRestore = false
  return false
}

export function resetAidaPictureInPicture() {
  const { incoming, pipWindow } = useAidaPipStore.getState()
  revokeIncomingPreviews(incoming)
  if (pipWindow) {
    skipOverlayRestore = true
    pipWindow.close()
  }
  useAidaPipStore.setState({
    active: false,
    dragging: false,
    pipWindow: null,
    container: null,
    chatSlot: null,
    generationActive: false,
    incoming: [],
  })
}

export function rememberIncoming(asset: IncomingAsset) {
  useAidaPipStore.setState(state => ({ incoming: [...state.incoming, asset] }))
}

export function failIncoming(id: string, error: string) {
  useAidaPipStore.setState(state => ({
    incoming: state.incoming.map(asset =>
      asset.id === id ? { ...asset, status: 'error' as const, error } : asset,
    ),
  }))
}

export function dismissIncoming(id: string) {
  const current = useAidaPipStore.getState().incoming.find(asset => asset.id === id)
  if (current) {
    revokeIncomingPreviews([current])
  }
  useAidaPipStore.setState(state => ({
    incoming: state.incoming.filter(asset => asset.id !== id),
  }))
}

export function removeIncoming(id: string) {
  useAidaPipStore.setState(state => ({
    incoming: state.incoming.filter(asset => asset.id !== id),
  }))
}

function revokeIncomingPreviews(assets: readonly IncomingAsset[]) {
  for (const asset of assets) {
    const url = asset.previewUrl
    if (url?.startsWith('blob:')) {
      URL.revokeObjectURL(url)
    }
  }
}
